import { render, staticRenderFns } from "./backGoodsIndex.vue?vue&type=template&id=08cce0e4&scoped=true&"
import script from "./backGoodsIndex.vue?vue&type=script&lang=js&"
export * from "./backGoodsIndex.vue?vue&type=script&lang=js&"
import style0 from "./backGoodsIndex.vue?vue&type=style&index=0&id=08cce0e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cce0e4",
  null
  
)

export default component.exports